document.addEventListener("DOMContentLoaded", function () {
    const toggleBtn = document.getElementById("toggleBtn");
    const shortContent = document.getElementById("shortContent");
    const fullContent = document.getElementById("fullContent");
    const richTextField = document.querySelector(".metafield-rich_text_field");

    toggleBtn.addEventListener("click", function () {
      const isExpanded = fullContent.style.display === "block";

      if (isExpanded) {
        fullContent.style.display = "none";
        shortContent.style.display = "block";
        toggleBtn.textContent = "Show More";
        if (richTextField) richTextField.style.display = "block";
      } else {
        fullContent.style.display = "block";
     
        toggleBtn.textContent = "Show Less";
        if (richTextField) richTextField.style.display = "none";
      }
    });
  });


document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll("h2.visually-hidden").forEach(function (el) {
    let span = document.createElement("span");
    span.innerHTML = el.innerHTML;
    span.className = el.className; // keep same class
    el.parentNode.replaceChild(span, el);
  });
});


document.addEventListener("DOMContentLoaded", function () {
  var container = document.querySelector("#shortContent .metafield-rich_text_field");
  if (container) {
    container.querySelectorAll("h2").forEach(function (el) {
      let span = document.createElement("span");
      span.innerHTML = el.innerHTML;
      span.className = el.className; // Keep same classes
      el.parentNode.replaceChild(span, el);
    });
  }
});
